import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './podcast-related-podcast-stack.component.scss';
import * as $ from 'jquery';
var PodcastRelatedPodcastStack = /** @class */ (function (_super) {
    tslib_1.__extends(PodcastRelatedPodcastStack, _super);
    function PodcastRelatedPodcastStack(element) {
        return _super.call(this, element) || this;
    }
    PodcastRelatedPodcastStack.prototype.init = function () {
        this.containers = Array.from(this.element.querySelectorAll('.podcast-related-podcast-stack-item__type-feature'));
        this.buttons = Array.from(this.element.querySelectorAll('.podcast-related-podcast-stack-item'));
    };
    PodcastRelatedPodcastStack.prototype.bindEvents = function () {
        var _this = this;
        this.buttons.map(function (item) { return item.addEventListener('click', function (event) {
            var element;
            var clickedExternal;
            var clickedTarget = event.target;
            element = clickedTarget.closest('.podcast-related-podcast-stack-item');
            var clickedIndex = element.getAttribute('data-index');
            if (element.getAttribute('data-youtube-id')) {
                clickedExternal = element.getAttribute('data-youtube-id');
            }
            _this.hideActiveButtons();
            element.classList.add('active');
            _this.hideContainers();
            _this.containers.map(function (item) {
                if (item.getAttribute('data-index') === clickedIndex) {
                    item.classList.remove('d-none');
                    if (document.querySelector('.header')) {
                        if (document.querySelector('.header').classList.contains('header--sticky')) {
                            $('html,body').animate({
                                scrollTop: $(_this.element).offset().top - 65
                            }, 'slow');
                        }
                        else {
                            $('html,body').animate({
                                scrollTop: $(_this.element).offset().top - 195
                            }, 'slow');
                        }
                    }
                    _this.pauseOtherAudios(item);
                }
            });
        }); });
    };
    PodcastRelatedPodcastStack.prototype.hideActiveButtons = function () {
        this.buttons.map(function (item) {
            item.classList.remove('active');
        });
    };
    PodcastRelatedPodcastStack.prototype.hideContainers = function () {
        this.containers.map(function (item) {
            item.classList.add('d-none');
        });
    };
    PodcastRelatedPodcastStack.prototype.pauseOtherAudios = function (container) {
        if (container) {
            var dataIndex = container.getAttribute('data-index');
            this.containers.map((function (containerChild) {
                var vidavee = Array.from(containerChild.querySelectorAll('audio'));
                vidavee.map(function (audio) {
                    audio.pause();
                });
            }));
        }
    };
    return PodcastRelatedPodcastStack;
}(Base));
export { PodcastRelatedPodcastStack };



//////////////////
// WEBPACK FOOTER
// ./components/podcast-related-podcast-stack/podcast-related-podcast-stack.component.ts
// module id = 437
// module chunks = 0